<ng-container *ngIf="loadingState$ | async as loadingState">
  <ng-container *ngIf="loadingState.loading">
    <div [ngSwitch]="loadingState.loadingConfig.id">
      <div *ngSwitchCase="loadingIdsEnum.PROGRESS_BAR">
        <ng-container *ngIf="isHandSet$ | async as boolean; else spinner">
          <app-loading-progress-bar></app-loading-progress-bar>
        </ng-container>
        <ng-template #spinner>
          <app-loading-spinner> </app-loading-spinner>
        </ng-template>
      </div>
      <div *ngSwitchCase="loadingIdsEnum.SPINNER">
        <app-loading-spinner> </app-loading-spinner>
      </div>
      <div *ngSwitchDefault>
        <app-loading-spinner> </app-loading-spinner>
      </div>
    </div>
  </ng-container>
</ng-container>
